export default "__VITE_ASSET__6aPJ9$AL__"